const { OSS_DOMAIN } = require('@/config/')
const { record: specialReligiousAssemblyRecord } = require('@/assets/js/specialReligiousAssembly')
/**
 * 工具类
 */
const utils = {
    // oss图片访问前缀
    joinImgPrefix(str) {
        if (!str) return ''
        if (typeof str === 'string') {
            if (str.indexOf('http') == -1) {
                return OSS_DOMAIN + str
            }
        }
        return str
    },
    // 将textarea中的换行换成br
    relaceToBr (str) {
        return str ? str.replace(/\n/gi, '<br>') : ''
    },
    // 特有法会、相似法会
    getSpecialReligiousAssemblyRecord (ids) {
      const keys = ids instanceof Array ? ids : (typeof ids === 'string' ? ids.split(',') : [ids])
      let res = []
      keys.forEach(key => {
        if (specialReligiousAssemblyRecord[Number(key)]) {
          res = res.concat(specialReligiousAssemblyRecord[Number(key)])
        }
      })
      return res
    }
}

module.exports = utils